export default {"src":"/_next/static/media/zhaket-licenced-icon.44200283.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};